export default __webpack_public_path__ + "static/media/editNavPattern.85b256e2.png";